import MENU from './menuTypes'
import { createActionCreators } from '../utils/actionHelpers'

const {
  fetchMenuElementRequest,
  fetchMenuElementSuccess,
  fetchMenuElementFailure,
} = createActionCreators(MENU)

export const fetchMenuElement = (apis, elementId) => (dispatch) => {
  dispatch(fetchMenuElementRequest({ elementId }))
  return apis.fetchMenuDetail()
    .then(({ data }) => dispatch(
      fetchMenuElementSuccess({
        elementId,
        menu: data,
      }),
    ))
    .catch((error) => dispatch(
      fetchMenuElementFailure({
        elementId,
        error,
      }),
    ))
}



// WEBPACK FOOTER //
// ./src/components/Canvas/renderer/redux/menu/menuAction.js